import React, { useState } from 'react';
import { Button, Box, Link, Typography } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import Modal from '../../components/Modals/Modal';
import { FileUploader } from '../../components/UI';
import { showMessage } from '../../utils/helper';
import { useDebounce } from '../../hooks/useDebounce';

function AgencyBulkUploadModal({
    open,
    onClose,
    dispatchUploadBulkLeads,
    onSuccess,
}) {
    const { debounce, isBouncing } = useDebounce();
    const [loading, setLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState('');

    const handleClose = () => {
        setFileUrl('');
        onClose && onClose();
    };

    const handleSubmit = () => {
        if (!fileUrl) {
            showMessage('Please upload a file', 'error');
            return;
        }
        debounce(() => {
            setLoading(true);
            dispatchUploadBulkLeads(
                { fileName: fileUrl },
                (resp) => {
                    setLoading(false);
                    const rows = resp?.response?.totalRows;
                    showMessage(
                        rows
                            ? `${rows} rows accepted and processing in the background. Track it under Upload History.`
                            : 'Upload accepted and processing in the background. Track it under Upload History.',
                        'success',
                    );
                    onSuccess && onSuccess();
                },
                () => {
                    setLoading(false);
                    showMessage('Bulk upload failed', 'error');
                },
            );
        });
    };

    const actions = [
        <Button
            key="cancel"
            variant="contained"
            color="default"
            className="cancelButton"
            onClick={handleClose}
            disableElevation
        >
            Cancel
        </Button>,
        <Button
            key="submit"
            variant="contained"
            color="primary"
            className="saveButton"
            disabled={isBouncing || loading || !fileUrl}
            onClick={handleSubmit}
            disableElevation
        >
            Bulk Upload
        </Button>,
    ];

    return (
        <Modal
            open={open}
            onClose={handleClose}
            title="Bulk Upload Leads"
            subtitle="Rows are processed in the background. The result file appears under Upload History once done."
            actions={actions}
            loading={loading}
        >
            <Box style={{ marginBottom: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                <GetAppIcon style={{ fontSize: 16, color: '#1976d2' }} />
                <Typography variant="body2">
                    <Link
                        href="/sample-leads-template.xlsx"
                        download="sample-leads-template.xlsx"
                        style={{ color: '#1976d2', cursor: 'pointer' }}
                    >
                        Download Sample Format
                    </Link>
                    <span style={{ color: '#666', marginLeft: 6 }}>
                        — columns: Name, Contact Number (exactly 10 digits, no 91), Agency Contact Number, Preferred Store, city_id, zone_id
                    </span>
                </Typography>
            </Box>
            <FileUploader
                placeholder="Upload Excel File (.xlsx only)"
                onFileUploaded={(url) => setFileUrl(url)}
                onRemoved={() => setFileUrl('')}
                isRequired
                accept=".xlsx"
                allowedExtensions={['xlsx']}
                onValidationFail={() =>
                    showMessage('Only .xlsx files are allowed. Please upload a valid Excel file.', 'error')
                }
            />
        </Modal>
    );
}

export default AgencyBulkUploadModal;
